import React from "react";
import { UserIcon } from "@heroicons/react/24/solid";



function Header({
  isLoggedIn,
  userName,
  onLogin,
  onLogout,
  onUpdate,
  onReset,
  onRegister, // ✅ dodano
  showBackButton = false,
  onBack
})
 {
  return (
    <header className="w-full px-6 py-4 flex justify-between items-center bg-white shadow-sm fixed top-0 left-0 z-50">

      {/* Levi del: uporabniško ime (če prijavljen) */}
      <div className="flex items-center space-x-4">
        {isLoggedIn && (
          <div className="relative group">
            <button className="flex items-center space-x-2 text-gray-700 hover:text-blue-600">
              <UserIcon className="h-6 w-6" />
              <span>{userName}</span>
              <svg className="w-4 h-4 ml-1" viewBox="0 0 24 24">
                <path d="M19 9l-7 7-7-7" stroke="currentColor" strokeWidth="2" fill="none" />
              </svg>
            </button>
            <div className="absolute mt-2 w-48 bg-white border border-gray-200 rounded shadow-lg opacity-0 group-hover:opacity-100 transition z-50">
              <button onClick={onUpdate} className="w-full text-left px-4 py-2 hover:bg-gray-100 text-sm">✏️ Uredi podatke</button>
              <button onClick={onReset} className="w-full text-left px-4 py-2 hover:bg-gray-100 text-sm">🔒 Spremeni geslo</button>
            </div>
          </div>
        )}
      </div>

      {/* Desni del: Gumbi za nazaj, prijavo/odjavo */}
      <div className="flex items-center space-x-3">
        {showBackButton && (
          <button
            onClick={onBack}
            className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded-md hover:bg-gray-100 transition"
          >
            ← Nazaj na nalaganje
          </button>
        )}
        {!isLoggedIn ? (
          <>
            <button onClick={onRegister} className="px-4 py-2 border border-blue-600 text-blue-600 rounded hover:bg-blue-50">
              Registracija
            </button>
            <button onClick={onLogin} className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700">
              Prijava
            </button>
          </>
        ) : (
          <button onClick={onLogout} className="px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700">
            Odjava
          </button>
        )}
      </div>
    </header>
  );
}

export default Header;
